<template lang="pug">
  nuxt-child
</template>

<script>
export default {
  layout: 'base',
  scrollToTop: true,
  head() {
    // const $t = this.$t.bind(this);

    return {
      meta: [
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/base.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/base.png'
        }
      ]
    };
  },
  meta: {
    logoText: 'system'
  }
};
</script>
